// extracted by css-extract-rspack-plugin
export default {"caption":"ModelResponseFormat-module__caption__ZvrDRfC"};